import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type {} from '@redux-devtools/extension'; // required for devtools typing

const UA = navigator.userAgent;
const IOS = UA.match(/iPhone|iPad|iPod/);
const ANDROID = UA.match(/Android/);

// eslint-disable-next-line no-nested-ternary
const platform = IOS ? 'ios' : ANDROID ? 'android' : 'unknown';

const PWA_SHOW_DELAY = 60 * 60 * 24 * 1000 * 7; //  60 * 60 * 24 * 1000 * 7 one week

export interface StoreState {
  lastCloseInstallPWA: number;
  showInstallPWA: boolean;
  setShowInstallPWA: (value: boolean) => void;
  showAppModal: boolean | string;
  setShowAppModal: (value: boolean | string) => void;
  authTab: 'advertiser' | 'publisher';
  setAuthTab: (value: 'advertiser' | 'publisher') => void;
}

const useMainStore = create<StoreState>()(
  devtools(
    persist(
      (set, get) => ({
        showAppModal: false,
        setShowAppModal: (value) => set({ showAppModal: value }),

        authTab: 'advertiser',
        setAuthTab: (value) => set({ authTab: value }),

        lastCloseInstallPWA: 0,
        showInstallPWA: false,
        setShowInstallPWA: (value) => {
          const dateNow = Date.now();
          if (value) {
            if (dateNow - get().lastCloseInstallPWA > PWA_SHOW_DELAY) {
              set({ showInstallPWA: value });
            }
          } else {
            set({ showInstallPWA: value, lastCloseInstallPWA: dateNow });
          }
        },
      }),
      {
        name: 'main-storage',
      }
    )
  )
);

export default useMainStore;
